import { formatDate } from "./date-helper";

export const formatUnlockedAt = (unlockedAt: string) => {
  return formatDate(unlockedAt, true);
};

export const selectListGenerator = (list: string[]) => {
  return list.map(v => {
    return { value: v, label: v };
  });
};
